import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Footer from '../components/Footer';

const SUPPORT_EMAIL = 'Support@Novareelhub.com';

const Section = ({ id, title, children }) => (
  <section id={id} className="mb-8">
    <h2 className="text-xl md:text-2xl font-semibold text-white mb-3">{title}</h2>
    <div className="text-white/80 leading-relaxed space-y-3">{children}</div>
  </section>
);

const Privacy = () => (
  <div className="bg-[#141414] min-h-screen text-white">
    <div className="px-4 md:px-14 py-6 border-b border-white/10 flex items-center gap-3 max-w-4xl mx-auto">
      <Link to="/" className="p-2 rounded hover:bg-white/10 transition-colors">
        <ArrowLeft className="w-5 h-5" />
      </Link>
      <h1 className="text-2xl md:text-3xl font-extrabold">Privacy Policy</h1>
    </div>

    <div className="max-w-4xl mx-auto px-4 md:px-14 py-10">
      <p className="text-sm text-white/60 mb-8">Last updated: 2025</p>

      <Section title="1. Overview">
        <p>NovaReelTV (“we”, “us”) values your privacy. This policy explains what information we collect, how we use it, and your choices.</p>
      </Section>

      <Section title="2. Information We Collect">
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>Account data:</strong> your phone number (used for OTP sign-in).</li>
          <li><strong>Profile data:</strong> name, avatar, kid flag and age (if provided).</li>
          <li><strong>Activity data:</strong> titles you save to My List and titles you open (Continue Watching).</li>
          <li><strong>Buddy chat:</strong> messages you send to “Your NovaReel Buddy” are stored to preserve conversation context.</li>
          <li><strong>Device &amp; log data:</strong> browser type, IP address, and standard access logs.</li>
        </ul>
      </Section>

      <Section title="3. How We Use Your Information">
        <ul className="list-disc pl-6 space-y-1">
          <li>To provide and personalize the Service (rows, recommendations, Buddy responses).</li>
          <li>To keep the Service secure and prevent abuse.</li>
          <li>To improve features based on aggregated usage.</li>
          <li>To serve relevant ads via Google AdSense and sponsorship placements.</li>
        </ul>
      </Section>

      <Section title="4. Advertising Partners">
        <p>We use Google AdSense to display ads. AdSense may set cookies and use device identifiers to serve interest-based ads. You can manage your ad preferences at <a className="underline text-white" href="https://adssettings.google.com" target="_blank" rel="noreferrer">Google Ads Settings</a>.</p>
      </Section>

      <Section title="5. AI Chatbot Data">
        <p>Messages you send to Your NovaReel Buddy are processed by a third-party AI provider to generate responses. We do not sell chat content, but we may review it for safety and improvement purposes.</p>
      </Section>

      <Section id="cookies" title="6. Cookies">
        <p>We use a small number of cookies and browser-storage items to keep you signed in and remember your selected profile. Ad partners may set additional cookies. You can clear cookies at any time from your browser settings.</p>
      </Section>

      <Section title="7. Data Sharing">
        <p>We do not sell your personal data. We share data only with service providers necessary to run the Service (hosting, database, AI provider, ad partners), all bound by their own privacy commitments.</p>
      </Section>

      <Section title="8. Your Rights">
        <p>You can view, edit, or delete your profiles at any time from the Profile Picker. To request full account deletion, email us at <a className="underline text-white" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.</p>
      </Section>

      <Section title="9. Children’s Privacy">
        <p>NovaReelTV is not directed at children under 13. Kid-flagged profiles created by an adult filter mature content and disable certain features to protect minors.</p>
      </Section>

      <Section title="10. Contact">
        <p>Questions or requests? Email <a className="underline text-white" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.</p>
      </Section>
    </div>

    <Footer />
  </div>
);

export default Privacy;
